"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toRoundedPercentage = exports.formatCompactViewDuration = exports.formatViewDuration = exports.formatDatetime = void 0;
var round_1 = __importDefault(require("lodash/round"));
var luxon_1 = require("luxon");
function formatDatetime(date, timeZone, showTimeZone) {
    if (showTimeZone === void 0) { showTimeZone = false; }
    return new Intl.DateTimeFormat(undefined, {
        day: "numeric",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hourCycle: "h12",
        timeZone: timeZone,
        timeZoneName: showTimeZone ? "short" : undefined,
    }).format(date);
}
exports.formatDatetime = formatDatetime;
function formatViewDuration(milliseconds) {
    var nearestSecond = (0, round_1.default)(milliseconds, -3);
    var duration = luxon_1.Duration.fromMillis(nearestSecond).shiftTo("minutes", "seconds");
    return "".concat(duration.minutes, "m ").concat(duration.seconds, "s");
}
exports.formatViewDuration = formatViewDuration;
function formatCompactViewDuration(milliseconds) {
    var nearestSecond = (0, round_1.default)(milliseconds, -3);
    return luxon_1.Duration.fromMillis(nearestSecond).shiftTo("hours", "minutes", "seconds").toFormat("hh:mm:ss");
}
exports.formatCompactViewDuration = formatCompactViewDuration;
function toRoundedPercentage(n) {
    return "".concat((0, round_1.default)(n * 100, 1), "%");
}
exports.toRoundedPercentage = toRoundedPercentage;
